import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../../../Button';
import Title from '../../../Title';
import Icon from '../../../Icon';
import { getDealInfo } from '../../../../reducers/DealInfo';
import { geti18n } from '../../../../reducers/i18n';
class DealDetails extends Component {
  renderDealDetails(){
    const i18n = this.props.i18n;
    const detailsInfo = this.props.detailsInfo;
    const { next } = this.props;
    return (
      <div className="deal-details text-center">
        <div className="row justify-content-center">
          <div className="col-10 col-sm-4">
            <Title text={i18n('onboarding.dealDetails.titleWelcome')} className="form__title deal-details__title" />
          </div>
        </div>
        <Icon name="house" className="deal-details__icon mb-4 mb-sm-5" />
        <div className="mb-5 pb-sm-4">
          <div className="row justify-content-center mb-4 mb-sm-0">
            <div className="col-9 col-sm-0">
              <p className="form__description mb-0">
                {i18n('onboarding.dealDetails.movingToVenn')}
                {detailsInfo.get('startDate')} {i18n('onboarding.dealDetails.apartmentAt')}{' '}
              </p>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-6 col-sm-0">
              <p className="form__description font-weight-bold text-large mb-4 pb-sm-3 ">
                {detailsInfo.get("address")} ,
                {i18n('onboarding.dealDetails.floor')} {detailsInfo.get("floor")}{' '}
              </p>
            </div>
          </div>
          <div className="row justify-content-center mb-2 mb-sm-0">
            <div className="col-6 col-sm-0">
              <p className="form__description mb-0">
                {i18n('onboarding.dealDetails.rent')} {detailsInfo.get("rent")} {i18n('onboarding.dealDetails.currencyName')}
              </p>
            </div>
          </div>
          <p>{i18n('onboarding.dealDetails.exclusions')} </p>
        </div>
        <Button text={i18n('onboarding.dealDetails.buttonText')} onClick={next} />
      </div>
    );
  }
  render() {
    return this.renderDealDetails();
  }
}

const mapStateToProps = state => ({
  i18n: geti18n(state),
  detailsInfo: getDealInfo(state)
});

export default connect(mapStateToProps)(DealDetails);



// WEBPACK FOOTER //
// ./src/components/Views/Onboarding/Steps/DealDetails.js